import {
  ADD_PAGE_STARTED,
  ADD_PAGE_COMPLETED,
  ADD_PAGE_ERROR
} from '../../actionTypes/pageActionTypes';

export const addCurrentPageStart = () => ({
  type: ADD_PAGE_STARTED
});
export const addCurrentPageSuccess = (data) => ({
  type: ADD_PAGE_COMPLETED,
  payLoad: data
});
export const addCurrentPageFailure = () => ({
  type: ADD_PAGE_ERROR
});

export const currentPage = (pageNumber) => {
  return (dispatch) => {
    dispatch(addCurrentPageStart());
    dispatch(addCurrentPageSuccess(pageNumber));
  };
};



// WEBPACK FOOTER //
// ./src/redux/actions/PaginationActions/currentPage.js